import { isSame } from '../strings/strings-utils';

/**
 * Security module codes of a retired module (D-175). A person's role grants for one stay exactly as
 * the server holds them: role sets, overrides and authorization are unchanged. But no surface that
 * draws modules from role grants shows it. GDC is the one retired module. Production's
 * AGWA.Staff.Developer role set still grants GDC roles, and without this its "Generic Document
 * Container" would show as an available feature.
 *
 * The security-module counterpart of RETIRED_STATE_DOMAINS (state-colour-registry.ts). The two are
 * separate lists because a state domain and a security module are keyed differently.
 */
export const RETIRED_SECURITY_MODULE_CODES: readonly string[] = ['GDC'];

/**
 * Whether a grant's module code names a retired module. The comparison ignores case, because the
 * code arrives as the server stored it.
 */
export function isRetiredSecurityModule(
  moduleCode: string | null | undefined
): boolean {
  return isSame(moduleCode, ...RETIRED_SECURITY_MODULE_CODES);
}
